import {IPackageRequirementsActionTypes, IPackageRequirementsState} from '../../models/packageRequirements'

const initialState: IPackageRequirementsState = {
    packageRequirements: [],
    packageRequirement: null,
    loading: true,
    error: null,
}

export const packageRequirementsReducer = (
    state = initialState,
    action: IPackageRequirementsActionTypes
): IPackageRequirementsState => {
    switch (action.type) {
        case 'FETCH_PACKAGE_REQUIREMENTS_START':
            return {
                ...state,
                loading: true,
                error: null,
            }
        case 'FETCH_PACKAGE_REQUIREMENTS_SUCCESS':
            return {
                ...state,
                loading: false,
                packageRequirements: action.payload,
                error: null,
            }
        case 'FETCH_PACKAGE_REQUIREMENTS_ERROR':
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        case 'FETCH_PACKAGE_REQUIREMENT_START':
        case 'CREATE_PACKAGE_REQUIREMENT_START':
        case 'UPDATE_PACKAGE_REQUIREMENT_START':
        case 'DELETE_PACKAGE_REQUIREMENT_START':
            return {
                ...state,
                loading: true,
                error: null,
            }
        case 'FETCH_PACKAGE_REQUIREMENT_SUCCESS':
        case 'CREATE_PACKAGE_REQUIREMENT_SUCCESS':
        case 'UPDATE_PACKAGE_REQUIREMENT_SUCCESS':
            return {
                ...state,
                loading: false,
                packageRequirement: action.payload,
                error: null,
            }
        case 'FETCH_PACKAGE_REQUIREMENT_ERROR':
        case 'CREATE_PACKAGE_REQUIREMENT_ERROR':
        case 'UPDATE_PACKAGE_REQUIREMENT_ERROR':
        case 'DELETE_PACKAGE_REQUIREMENT_ERROR':
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        case 'DELETE_PACKAGE_REQUIREMENT_SUCCESS':
            return {
                ...state,
                loading: false,
                packageRequirements: state.packageRequirements.filter(
                    ({id}) => id !== action.payload
                ),
                error: null,
            }
        default:
            return state
    }
} 